import { inject, Injectable } from '@angular/core';
import { DeviceStoreActions, LocationsRouterStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { isNonEmptyString } from '@rocksoft/shared';
import { combineLatest, Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DeviceResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return combineLatest([
      this.store.select(LocationsRouterStoreSelectors.selectBrandId),
      this.store.select(LocationsRouterStoreSelectors.selectLocationId),
    ]).pipe(
      filter((ids): ids is [string, string] => isNonEmptyString(ids[0]) && isNonEmptyString(ids[1])),
      tap(([brandId, locationId]) => {
        this.store.dispatch(
          DeviceStoreActions.DeviceResolverActions.devicesRequested({
            brandId,
            locationId,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
